import CookieComponent from "./components/cookie-component";
import CookieModalComponent from "./components/cookie-modal-component";
import {getCookie} from "./utils/get-cookie";
import {setCookie} from "./utils/set-cookie";
import {RenderPosition, remove, render} from "./utils/render";


export const renderCookie = () => {
  const container = document.querySelector(`body`);
  if (!container) {
    return;
  }

  const isAgree = getCookie(`agree_cookie`);
  if (isAgree) {
    return;
  }

  const component = new CookieComponent();
  component.setMoreButtonClickHandler(() => {
    const removePopup = () => {
      modalComponent.getElement().classList.add(`modal--hide`);
      document.querySelector(`body`).classList.remove(`overflowHidden`);
      document.removeEventListener(`keydown`, onEscPressModalHandler);
      setTimeout(() => remove(modalComponent), 1000);
    };

    const onEscPressModalHandler = (evt) => {
      if (evt.key === `Escape`) {
        removePopup();
      }
    };

    document.querySelector(`body`).classList.add(`overflowHidden`);
    document.addEventListener(`keydown`, onEscPressModalHandler);

    const modalComponent = new CookieModalComponent();
    render(document.querySelector(`body`), modalComponent.getElement(), RenderPosition.BEFOREEND);

    modalComponent.setCloseButtonClickHandler(() => removePopup());
    modalComponent.setOverlayClickHandler(() => removePopup());

    modalComponent.setShowClass();
  });

  component.setAgreeButtonClickHandler(() => {
    setCookie(`agree_cookie`, `1`, 365);
    component.getElement().classList.add(`cookie--hide`);
    setTimeout(() => remove(component), 1000);
  });

  render(container, component.getElement(), RenderPosition.BEFOREEND);
};
